import { accountsSelectors } from 'app-components/flux/accounts';
import { getEnvironmentConfig, httpClientInterface } from 'app-components/utils/core';
import store from 'app-components/utils/redux-store';
import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';

const topTickers: string[] = [
  'NVDA',
  'AMZN',
  'AAPL',
  'VOO',
  'VTI',
  'VWO',
  'BTC',
  'TSLA',
  'MSFT',
  'AVGO',
  'GOOGL',
  'VEA',
  'QQQ',
  'PLTR',
  'NFLX',
  'META',
  'FXAIX',
  'GOOG',
  'SPY',
  'VXUS',
  'UBER',
  'AMD',
  'ETH',
  'USD',
  'VUG',
  'VTV',
  'BND',
  'SCHF',
  'COST',
  'AGG',
  'INTC',
  'IEMG',
  'IJR',
  'DIS',
  'IVV',
  'SCHD',
  'V',
  'VFIAX',
  'IJH',
  'VGT',
  'RIVN',
  'ABBV',
  'ADBE',
  'ORCL',
  'IEFA',
  'SCHG',
  'AXP',
  'SPSM',
  'WMT',
  'SPAXX',
  'VZ',
  'SPLG',
  'PG',
  'BRK.B',
];

const mockHoldings = async () => {
  if (store) {
    const startDate = DateTime.fromISO('2024-01-01');
    const endDate = DateTime.fromISO('2024-12-31');
    const requestUrl = `${getEnvironmentConfig().services_url}/v2/investments/historical-quotes`;
    const daysBetween = endDate.diff(startDate, 'days').days;
    const investmentAccounts =
      accountsSelectors.getInvestmentAccounts(store.getState())?.toIndexedSeq()?.toArray() || [];
    const holdings: any[] = [];
    for (const symbol of topTickers) {
      const randomIndex = Math.floor(Math.random() * investmentAccounts.length);
      const accountsSelected: Set<string> = new Set([investmentAccounts[randomIndex]?.id || '']);
      investmentAccounts.forEach((accountSelected) => {
        if (Math.random() > 0.9) {
          accountsSelected.add(accountSelected.id || '');
        }
      });
      await Promise.all(
        Array.from(accountsSelected).map(async (accountId) => {
          let date: string = '';
          do {
            const randomDays = Math.floor(Math.random() * daysBetween);
            const candidate = startDate.plus({ days: randomDays });
            if (candidate.weekday !== 6 && candidate.weekday !== 7) {
              date = candidate.toISODate() || '';
            }
          } while (!date);
          let response: any;
          try {
            response = await httpClientInterface.send('GET', requestUrl, undefined, undefined, {
              symbol,
              startDate: date,
              endDate: date,
              intervalType: 'DAILY',
              splits: false,
            });
          } catch (_e) {
            // Intentionally ignore errors for mock data generation
          }
          const quote = response?.data?.resources?.[0];
          const quantity = Math.floor(Math.random() * 20) + 1;
          holdings.push({
            clientId: uuidv4().toUpperCase(),
            accountId,
            quantity,
            securityType: 'STOCK',
            securityId: symbol,
            symbol,
            securityIdType: 'QCSSYMBOL',
            ...(quote?.close && {
              costBasis: Number((quote.close * quantity).toFixed(4)),
            }),
          });
        }),
      );
    }

    return holdings;
  }

  return [];
};

export default mockHoldings;
